module.exports = __webpack_public_path__ + "img/4.41e7b3c1.jpg";